const CONTAINER_CLASS = 'pointer-events-none absolute inset-x-0 z-20 flex items-center';
const DOT_CLASS = 'h-1.5 w-1.5 rounded-full bg-primary';
const LINE_CLASS = 'h-[0.7px] flex-1 bg-primary';

type CurrentTimeIndicatorProps = Readonly<{ offsetPx: number }>;

export function CurrentTimeIndicator({ offsetPx }: CurrentTimeIndicatorProps) {
    return (
        <div
            aria-hidden
            className={CONTAINER_CLASS}
            style={{ top: offsetPx, transform: 'translateY(-50%)' }}
        >
            <div className={DOT_CLASS} />
            <div className={LINE_CLASS} />
        </div>
    );
}
